define.alias("shared/components/shared/typeform-survey-trigger", "calendar/components/shared/typeform-survey-trigger");